<template>
  <div style="width: 100%">
    <bread-crumb :breadcrumb-items="breadcrumbsItems" />
    <div class="container default-padding">
      <div class="section-padding">
        <div class="primary-heading">{{ terms.title }}</div>
        <div class="caption">
          {{ terms.subtitle }}
        </div>
      </div>

      <div v-html="terms.content"></div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { labels } from "@/common";

  import BreadCrumb from "../components/BreadCrumb.vue";

  export default {
    name: "TermsAndConditions",

    components: {
      BreadCrumb,
    },

    data() {
      return {
        labels,
        breadcrumbsItems: [{ name: "Privacy Policy", path: "" }],
      };
    },

    computed: {
      ...mapState({
        allContents: (state) => state.editableContent.editableContents.data,
      }),

      terms() {
        return (
          this.allContents &&
          this.allContents.find(
            (c) => c.title.toLowerCase() == "terms & conditions"
          )
        );
      },
    },
  };
</script>

<style lang="scss" scoped></style>
